import script from "./ConfiguradorBloqueModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfiguradorBloqueModal.vue?vue&type=script&setup=true&lang=ts"

import "./ConfiguradorBloqueModal.vue?vue&type=style&index=0&id=69abaf51&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69abaf51"]])

export default __exports__